import { Layout } from './layout.model';

export class FullLayout implements Layout {
  hasStatusBar: boolean = false;
  hasMenu: boolean = false;
  hasLayout: boolean = true;
  hasLayoutPadding = true;
  autoHideStatusBar = false;
}
